import { useEffect } from 'react'
import { getUserState, useSelector } from '../store'

export const Hotjar = () => {
  const { user, companyConsumption } = useSelector(getUserState)

  useEffect(() => {
    const script = document.createElement('script')
    script.innerHTML = `
            (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${import.meta.env.VITE_HOTJAR_SITE_ID},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `
    document.head.appendChild(script)
    return () => {
      try {
        document.head.removeChild(script)
      }
      catch (e) {
        console.log("Error in Hotjar", e)
      }
    }
  }, [])

  useEffect(() => {
    if (
      user?.user_cognito_id !== undefined &&
      companyConsumption?.company_id !== undefined
    ) {
      const data = {
        company_id: user?.company_id ?? '',
        user_cognito_id: user?.user_cognito_id ?? '',
        user_hubspot_id: user?.user_hubspot_id ?? '',
        email: user?.user_email ?? '',
        user_firstname: user?.user_firstname ?? '',
        user_lastname: user?.user_lastname ?? '',
        role: user?.role ?? '',
        creation_date: user?.creation_date ?? '',
        subscription_tier: companyConsumption?.subscription_tier ?? '',
        voucher_balance: companyConsumption?.voucher_balance ?? '',
        company_balance: companyConsumption?.company_balance ?? '',
        current_plan: companyConsumption?.current_plan ?? '',
      }
      const hj = (window as any)?.hj
      if (hj !== undefined && typeof hj === 'function') {
        hj('identify', user?.user_cognito_id, data)
      }
    }
  }, [user?.user_cognito_id, companyConsumption?.company_id])

  return null
}
